import { COLLECTION_VIEW_ROUTE } from '@config/routeNames.js'
import i18n from '@plugins/localisation.js'
import { Settings } from '@config/game.js'

export const schema = {
  config: [
    {
      label: 'name',
      key: 'name',
      cellClass: 'tw-text-left',
      type: 'content',
      collection: true,
      to: (item) => ({
        name: COLLECTION_VIEW_ROUTE,
        params: { collection: item.name_id },
      }),
    },
    {
      label: 'filesize',
      format: 'size',
      lowOpacity: true,
      type: 'string',
      key: 'filesize',
      cellClass: 'tw-hidden xl:tw-table-cell tw-text-left',
      sort: {
        direction: 'asc',
      },
    },
    {
      label: 'ugc_count',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.mods_total',
      cellClass: 'tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'followers',
      format: 'number',
      lowOpacity: true,
      type: 'string',
      key: 'stats.followers_total',
      cellClass: 'tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'added',
      key: 'date_live',
      type: 'string',
      format: 'time',
      lowOpacity: true,
      cellClass: 'tw-hidden lg:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
    {
      label: 'updated',
      key: 'date_updated',
      type: 'string',
      format: 'time',
      lowOpacity: true,
      cellClass: 'tw-hidden xl:tw-table-cell tw-text-left',
      sort: {
        direction: 'desc',
      },
    },
  ],
  defaultSort: 'date_updated',
}

if (Settings.value.allowSubscribing) {
  schema.config.push({
    type: 'group',
    cellClass: 'tw-text-right',
    actionCell: true,
    sortable: false,
    group: [
      (item) => ({
        type: 'action',
        attrs: {
          class: 'tw-uppercase',
          primary: item.unfollowed,
          secondary: !item.unfollowed,
        },
        mobileIcon: item.unfollowed ? 'redo-alt' : 'times',
        tooltip: item.unfollowed
          ? i18n.global.t('follow')
          : i18n.global.t('unfollow'),
        text: item.unfollowed
          ? i18n.global.t('follow')
          : i18n.global.t('unfollow'),
        onClick: 'toggleFollow',
      }),
    ],
  })
}
